import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import SelectComponent, { defaultSelectStyles } from 'components/Inputs/SelectComponent';
import { deletedStatusOptions, NAME } from './constants';
import { IsDeletedSelectTransFields } from './types';
import { isDeletedSelectTranslations } from './translations';

const IsDeletedSelect: FC = () => {
  const { setValue, getValues } = useFormContext();

  const { t } = useMyTranslations<IsDeletedSelectTransFields>([isDeletedSelectTranslations.name]);

  useEffect(() => {
    const val = getValues(NAME);
    setValue(NAME, { id: val.id, name: t(val.name) });
  }, []);

  return (
    <SelectComponent
      name={NAME}
      options={deletedStatusOptions.map((item) => ({ ...item, name: t(item.name) }))}
      styleProps={defaultSelectStyles}
      optionValue='id'
      optionLabel='name'
      isClearable={false}
    />
  );
};

export default IsDeletedSelect;
